angular.module('leanlaw').directive("onScroll", ['$timeout', function ($timeout) {
  return {
    scope: {
      onScroll: "="
    },
    link: function (scope, element, attrs) {
      // Pass scroll event
      element.on("scroll", function (e) {
        scope.onScroll(e);
      });
    }
  };
}]);